var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 50.6697 75.8223 60.3638 69.0137 67.5356C61.7252 75.2128 51.4217 57.668 40 57.668C28.5783 57.668 18.2748 75.2128 10.9862 67.5356C4.1775 60.3638 0 50.6697 0 40H0Z",
    fill: "#82F1D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9998 40.0008C79.9998 39.3862 79.9851 38.7752 79.9577 38.1675L54.093 12.3028L54.619 13.397L49.2726 8.05078L28.5 31.5L36.9512 45.5456C36.9512 45.5456 68.1537 68.4409 69.0129 67.5359C75.8218 60.3642 79.9998 50.6706 79.9998 40.0008Z",
    fill: "#17EFB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2451 39.0977H48.7545V57.6664H31.2451V39.0977Z",
    fill: "#EAA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 39.0996H48.7547V57.6684H40V39.0996Z",
    fill: "#D38C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2451 51.1406H48.7545V69.3241H31.2451V51.1406Z",
    fill: "#EAA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 51.1406H48.7547V69.3241H40V51.1406Z",
    fill: "#D38C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0145 59.6047V67.5375C62.4144 74.4875 53.3457 79.0703 43.2113 79.8734C42.1519 79.9594 41.0816 80.0016 40.0004 80.0016C38.9191 80.0016 37.8488 79.9594 36.7894 79.8734C26.6551 79.0703 17.5863 74.4875 10.9863 67.5375V59.6047C10.9863 54.9297 14.7754 51.1406 19.4504 51.1406H26.5051C26.5051 51.1406 34.0066 63.3531 40.0004 63.3531C45.9941 63.3531 53.4957 51.1406 53.4957 51.1406H60.5504C65.2254 51.1406 69.0145 54.9297 69.0145 59.6047Z",
    fill: "#6C8897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0141 59.6047V67.5375C61.725 75.2141 51.4219 80.0016 40 80.0016V62.5609C48.1548 64.2097 53.4958 51.1406 53.4958 51.1406H60.55C65.225 51.1406 69.0141 54.9297 69.0141 59.6047Z",
    fill: "#2F576C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.583 65.5703V76.918C22.8377 76.1898 21.1533 75.3383 19.5439 74.3789V65.5703H24.583Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M60.4561 65.5703V74.3789C58.8467 75.3383 57.1623 76.1898 55.417 76.918V65.5703H60.4561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9997 65.2191C32.5581 65.2191 26.5039 59.1648 26.5039 51.7233V51.1406H31.245V51.7233C31.245 56.5802 35.1428 60.5316 39.9997 60.5316C44.8566 60.5316 48.7544 56.5802 48.7544 51.7233V51.1406H53.4955V51.7233C53.4955 59.1648 47.4413 65.2191 39.9997 65.2191Z",
    fill: "#BF3537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4953 51.1406V51.7234C53.4953 58.0578 49.1078 63.3891 43.2109 64.8312C42.1812 65.0844 41.1063 65.2188 40 65.2188V60.5312C44.8562 60.5312 48.7547 56.5797 48.7547 51.7234V51.1406H53.4953Z",
    fill: "#B91618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7892 23.7859C53.2067 14.9421 46.0531 11.6738 39.9999 11.6738C33.9468 11.6738 26.7932 14.9421 26.2107 23.7859C24.6454 24.0887 23.5335 26.1416 23.7085 27.8016L23.9768 31.5793C24.1604 33.3226 25.6928 34.5951 27.3815 34.4057L27.6728 34.3741C31.1318 43.6626 36.5567 44.631 39.9999 45.1749C43.4434 44.6312 48.8681 43.6627 52.3271 34.3741L52.6184 34.4057C54.307 34.5951 55.8393 33.3226 56.0231 31.5793L56.2914 27.8016C56.4664 26.1416 55.3545 24.0887 53.7892 23.7859Z",
    fill: "#FFC397"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2916 27.8016L56.0233 31.5793C55.8397 33.3226 54.3073 34.5951 52.6186 34.4057L52.3273 34.3741C51.1452 37.5449 49.7348 39.7473 48.2527 41.2924C45.3947 44.2738 42.2684 44.8162 40 45.1748V11.6738C46.0531 11.6738 53.2067 14.9421 53.7892 23.7859C55.3547 24.0887 56.4666 26.1416 56.2916 27.8016Z",
    fill: "#EAA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6737 10.6073C51.3313 10.0473 50.9057 9.52608 50.3623 8.99327C46.7816 5.48343 40.6574 4.16686 35.3912 5.21202C30.5773 6.16749 26.5132 9.16311 25.0891 12.8897C22.3218 20.1311 27.2935 29.3678 27.2935 29.3678C27.2935 29.3678 30.1757 20.2683 39.0969 20.2683C43.2951 20.2683 46.3182 19.5884 48.4559 18.7425C49.456 23.1639 53.203 29.3678 53.203 29.3678C59.0888 16.1284 54.7327 11.9308 51.6737 10.6073Z",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2031 29.3688C53.2031 29.3688 49.4562 23.1656 48.4562 18.7437C46.475 19.5266 43.7328 20.1687 40 20.2578V4.89062C43.9266 5.09062 47.7984 6.47969 50.3625 8.99375C50.9062 9.52656 51.3312 10.0484 51.6734 10.6078C54.7328 11.9312 59.0891 16.1297 53.2031 29.3688Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.d0e0d188922d2726786e9cddb4c319dc.svg";
export { ForwardRef as ReactComponent };